import React, { useEffect, useState, useRef } from "react";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import deleteImg from '../../../assets/images/delete.png';
import { FaArrowsRotate } from "react-icons/fa6";
import BasicModal from "../../core/BaseComponents/Modal";
import { callAPI } from "../../../axios";
import { getChainIdLS } from "../../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { isEqual } from 'lodash';

const RemoveBoxes = (props) => {
    // const { removedBoxesResponse, unMappedBoxes } = props
    const [rowSelections, setRowSelections] = useState({});
    const [removedBoxesList, setRemovedBoxesList] = useState([]);
    const [removedBoxesFilteredList, setRemovedBoxesFilteredList] = useState([]);
    const [mapedCdsnList, setMappedCdsnList] = useState([]);
    const [confirmPopUp, setConfirmPopUp] = useState(false);
    const [search, setSearch] = useState("");

    const isCdsnConfirmRef = useRef({
        isCdsnConfirmData: null,
        userConformationModalData: null,
    });

    const handleChange = (event, rowId) => {
        setRowSelections(prev => ({
            ...prev,
            [rowId]: {
                ...(prev[rowId] || {}),
                action: event.target.value,
            },
        }));
    };

    const handleSelectCdsn = (event, rowId) => {
        setRowSelections(prev => ({
            ...prev,
            [rowId]: {
                ...(prev[rowId] || {}),
                cdsn: event.target.value,
            },
        }));
    };

    const mappingConfirmHandler = (rowCdsn, selectedActionValue, mappedCdsn) => {
        let payload;
        if (selectedActionValue === "Clone To") {
            if (mappedCdsn === undefined) {
                setRowSelections(prev => ({
                    ...prev,
                    [rowCdsn]: {
                        ...(prev[rowCdsn] || {}),
                        error: 'Please select the cdsn',
                    },
                }));
                return;
            }
            payload = {
                operation: "clone",
                removedCdsn: rowCdsn,
                mappedCdsn: mappedCdsn.toString()
            }
        } else {
            payload = {
                operation: "delete",
                removedCdsn: rowCdsn,
                mappedCdsn: ''
            }
        }
        setConfirmPopUp(true);
        const newModalRefData = {
            isCdsnConfirmData: {
                payload
            },
            userConformationModalData: null,
        };
        isCdsnConfirmRef.current = newModalRefData;
    }

    const renderActionIcon = (row) => {
        const rowId = row?.cdsn;
        const currentSelection = rowSelections[rowId] || {};
        const selectedActionValue = currentSelection.action || '';

        return <div className={`resync-removeboxes ${rowSelections[row?.cdsn]?.error && rowSelections[row.cdsn]?.error !== "" ? 'mt-3' : ''}`}>
            <FormControl className={`me-3 ${selectedActionValue !== "" ? '' : 'action-item'}`}>
                <InputLabel id={`select-action-${row?.cdsn}`}>Select</InputLabel>
                <Select
                    labelId={`select-action-${row?.cdsn}`}
                    id={`select-action-select-${row?.cdsn}`}
                    value={selectedActionValue}
                    label="Select"
                    onChange={(e) => handleChange(e, row?.cdsn)}
                >
                    {props?.chainId.navSelectedhotelName?.[0]?.viewType === "hotelApp" && ((row?.roomNo !== "NA" || row?.apkVersion !== "NA") && mapedCdsnList.length > 0) && (
                        <MenuItem value="Clone To">Clone To</MenuItem>
                    )}
                    {props?.chainId.navSelectedhotelName?.[0]?.viewType === "custom" && ((row?.roomNo !== "NA" || row?.roomType !== "NA") && mapedCdsnList.length > 0) && (
                        <MenuItem value="Clone To">Clone To</MenuItem>
                    )}
                    <MenuItem value="Delete Existing Configuration">Delete Existing Configuration</MenuItem>
                </Select>
            </FormControl>
            {(selectedActionValue === "Clone To" && mapedCdsnList.length > 0) && <FormControl className={`me-3 ${rowSelections[row.cdsn]?.cdsn !== undefined ? '' : 'selectedcdsn'}`}>
                <InputLabel id={`select-cdsn-${row?.cdsn}`} className="cdsn-label">Select CDSN</InputLabel>
                <Select
                    labelId={`select-cdsn-${row?.cdsn}`}
                    id={`select-action-cdsn-${row?.cdsn}`}
                    value={rowSelections[row.cdsn]?.cdsn || ''}
                    label="Select CDSN"
                    onChange={(e) => handleSelectCdsn(e, row?.cdsn)}
                >
                    {mapedCdsnList?.map((cdsn) => (
                        <MenuItem key={cdsn} value={cdsn}>{cdsn}</MenuItem>
                    ))}
                </Select>
                {rowSelections[row?.cdsn]?.error && rowSelections[row.cdsn]?.error !== "" && <p className="required mb-0">{rowSelections[row.cdsn]?.error}</p>}
            </FormControl>
            }
            {selectedActionValue !== "" && <button type="button" className={`create-btn ${selectedActionValue !== "Clone To" ? "bg-danger border-danger" : ""}`} onClick={() => mappingConfirmHandler(rowId, selectedActionValue, rowSelections[row.cdsn]?.cdsn)}>{selectedActionValue === "Clone To" ? 'Clone' : 'Delete'}</button>}
        </div>
    }

    const columns = [
        { field: "cdsn", headerName: "CDSN", flex: 1 },
        { field: "roomNo", headerName: "Current Room Number", flex: 1, row: true, disableSortIcon: true, renderCell: (row) => <p className="mb-0">{row?.roomNo !== "NA" ? row?.roomNo : "NA"}</p> },
        { field: props?.chainId.navSelectedhotelName?.[0]?.viewType === "custom"?"roomType":"apkVersion", headerName: props?.chainId.navSelectedhotelName?.[0]?.viewType === "custom"?"Current Room Type":"Current APK Version", flex: 1, row: true, disableSortIcon: true, renderCell: (row) => <p className="mb-0">{`${props?.chainId.navSelectedhotelName?.[0]?.viewType === "custom"?`${row?.roomType}`:row?.apkVersion !== "NA" ? row?.apkVersion : "NA"}`}</p> },
        {
            field: "actionCell",
            row: true,
            headerName: "Actions",
            flex: 0.5,
            renderCell: renderActionIcon,
            sortDirection: false,
            disableSortIcon: true,
        },
    ];

    useEffect(() => {
        if (!isEqual(props.removedBoxesResponse, removedBoxesList)) {
            setRemovedBoxesList(props.removedBoxesResponse);
            setRemovedBoxesFilteredList(props.removedBoxesResponse);
        }

        if (!isEqual(props.unMappedBoxes, mapedCdsnList)) {
            setMappedCdsnList(props.unMappedBoxes);
        }
    }, [props.removedBoxesResponse, props.unMappedBoxes]);

    useEffect(() => {
        props?.manuallyRemovedBoxesListHandler(removedBoxesFilteredList);
    }, [removedBoxesFilteredList]);

    const initialRender = useRef(true);

    // useEffect(() => {
    //     props?.manuallyRemovedUnMappedCdsnHandler(mapedCdsnList);
    // }, [mapedCdsnList]);

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false
        }
        else {
            props?.manuallyRemovedUnMappedCdsnHandler(mapedCdsnList);
        }
    }, [mapedCdsnList])

    const popupCloseHandler = () => {
        setConfirmPopUp(false);
    };

    const confirmChainIdHandler = () => {
        const payload = isCdsnConfirmRef.current?.isCdsnConfirmData?.payload;
        const mappedCdsn = payload?.mappedCdsn;
        const removedCdsn = payload?.removedCdsn;

        const apiPath = `/chainid/cdsn/confirm`;
        callAPI(apiPath, "POST", isCdsnConfirmRef.current?.isCdsnConfirmData?.payload, { chainId: getChainIdLS() })
            .then(response => {
                setRemovedBoxesFilteredList(prevRows => prevRows.filter(row => row.cdsn !== removedCdsn));
                setMappedCdsnList(prevRows => prevRows.filter(cdsn => cdsn !== mappedCdsn));
                let successMessage = response.message
                const newModalRefData = {
                    isCdsnConfirmData: null,
                    userConformationModalData: {
                        successMessage
                    },
                };
                isCdsnConfirmRef.current = newModalRefData;
                setSearch('');
                setRowSelections({});
            })
            .catch(err => {
                console.warn(err.message);
                setConfirmPopUp(false);
            });

    }

    useEffect(() => {
        const originalData = JSON.parse(JSON.stringify(removedBoxesFilteredList));
        if (!search.trim()) {
            setRemovedBoxesList(originalData);
        } else {
            const filteredData = originalData.filter((item) =>
                item?.cdsn?.toString().toLowerCase().includes(search.toLowerCase())
            );
            setRemovedBoxesList(filteredData);
        }
    }, [search, removedBoxesFilteredList]);


    const onSearchChangeHandler = (e) => {
        setSearch(e.target.value);
    };

    return (
        <>
            <div className="ms-auto my-2 search-input w-25">
                <FontAwesomeIcon icon={faSearch} className="icon-magnifier" />
                <input
                    type="text"
                    name="input-search"
                    className="form-control"
                    placeholder="Search CDSN"
                    onChange={(e) => onSearchChangeHandler(e)}
                    value={search}
                    onKeyPress={(e) => {
                        e.key === "Enter" && e.preventDefault();
                    }}
                />
            </div>
            <TableWrapper
                data={removedBoxesList}
                columns={columns}
                noPagination={true}
            />
            {confirmPopUp && <BasicModal
                popupOpen={confirmPopUp}
                bodyMessage={<>
                    {isCdsnConfirmRef.current?.isCdsnConfirmData?.payload?.operation === 'delete' ? <img src={deleteImg} alt="approve" className="w-40px" /> : <img src={deleteImg} alt="approve" className="w-40px" />}

                    <div className="delete-hotel mb-3">{isCdsnConfirmRef.current?.isCdsnConfirmData ?
                        <div className="confirm-delete-hotel">
                            <p>Do you really want to {isCdsnConfirmRef.current?.isCdsnConfirmData?.payload?.operation === 'delete' ? 'delete' : 'clone'} the CDSN? </p>
                        </div> :
                        isCdsnConfirmRef.current?.userConformationModalData?.successMessage}</div>
                </>
                }
                footer={
                    isCdsnConfirmRef.current?.isCdsnConfirmData ?
                        {
                            primaryButton: {
                                buttonName: "Cancel",
                                action: popupCloseHandler
                            }
                            ,
                            secondaryButton: {
                                buttonName: `${isCdsnConfirmRef.current?.isCdsnConfirmData?.payload?.operation === 'delete' ? 'Delete' : 'Clone'}`,
                                action: confirmChainIdHandler
                            }
                        } : {
                            secondaryButton: {
                                buttonName: "OK",
                                action: popupCloseHandler
                            }
                        }
                }
            />}
        </>
    )
}

export default RemoveBoxes;